import React from 'react'

// Styles
import './index.scss'

const DropdownButton = (props) => {
  const { menu, id, title, menuAlign } = props
  return (
    <div className="dropdown-button">
      <button
        type="button"
        className="dropdown-toggle"
        id={id}
      >
        {title}
      </button>

      <div className={`dropdown-menu ${menuAlign}`}
      >
        {
          menu.map((item, i) => {
            return (
              <div key={`dropdownMenu${i}`}>
                <a
                  href={item.link}
                >
                  <button className="btn menu-btn">{item.title}</button>
                </a>
              </div>
            )
          })
        }
      </div>
    </div>
  )
}

export default DropdownButton